'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIMessage = function AUIMessage(_ref) {
    var type = _ref.type,
        title = _ref.title,
        children = _ref.children,
        isCloseable = _ref.isCloseable,
        onClose = _ref.onClose;

    var typeClass = void 0;
    if (type) {
        typeClass = 'aui-message-' + type;
    }

    var classes = (0, _classnames2.default)('aui-message', typeClass, {
        closeable: isCloseable
    });

    return _react2.default.createElement(
        'div',
        { className: classes },
        !title ? null : _react2.default.createElement(
            'p',
            { className: 'title' },
            _react2.default.createElement(
                'strong',
                null,
                title
            )
        ),
        isCloseable ? _react2.default.createElement('span', { className: 'aui-icon icon-close', role: 'button', tabIndex: '0', onClick: onClose }) : null,
        children
    );
};

AUIMessage.displayName = 'AUIMessage';
AUIMessage.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    title: _propTypes2.default.string,
    isCloseable: _propTypes2.default.bool,
    type: _propTypes2.default.oneOf(['warning', 'error', 'success', 'hint', 'info']),
    /**
     * Callback for closing AUIMessage
     */
    onClose: _propTypes2.default.func
};

exports.default = AUIMessage;
//# sourceMappingURL=AUIMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIMessage.js
// module id = 189
// module chunks = 0